<div mat-dialog-actions class="d-flex align-items-center my-account-mobile-dialog-actions">
  <h1>Menu</h1>
  <button class="btn btn-link p-0 border-0">
    <mat-icon class="material-icons-sharp light md-16" (click)="closeMyAccountMobileDialog()">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="my-account-mobile-dialog-content">
  <!-- My Account Menu -->
  <div
    class="my-account-mobile-dialog-content-list"
    *ngFor="let myAccountNav of myAccountLinksOverride || myAccountLinks"
  >
    <mat-list-item (click)="onClickSubMenu($event, 0)" *ngIf="myAccountNav.children" disableRipple>
      <mat-icon class="material-icons-sharp light">menu</mat-icon>
      <mat-icon class="material-icons-sharp light ml-auto menu-button" [class.rotated]="showSubSubMenu[0]"
        >expand_more</mat-icon
      >
    </mat-list-item>
    <div
      class="submenu-container"
      [class.expanded]="showSubSubMenu[0]"
      [class.d-none]="!showSubSubMenu[0]"
      *ngIf="myAccountNav.children && showSubSubMenu[0]"
    >
      <div class="subsubmenu-container d-xl-none" *ngFor="let myAccountNavChild of myAccountNav.children">
        <mat-list-item
          (click)="onClick(myAccountNavChild.url, myAccountNavChild.styleClasses)"
          disableRipple
          *ngIf="myAccountNavChild.url"
          [class.hidden]="myAccountNavChild.url === '/dealer-selection' && !asmEnabled"
        >
          <span class="submenu">{{ myAccountNavChild.title | titlecase }}</span>
        </mat-list-item>
      </div>
    </div>
  </div>
  <!-- Header Links -->
  <div class="my-account-mobile-dialog-content-list" *ngFor="let headerLinkComponent of headerLinksMobileNavEntries">
    <mat-list-item (click)="onClick(headerLinkComponent.url)" disableRipple>
      <span class="submenu">{{ headerLinkComponent.linkName | titlecase }}</span>
    </mat-list-item>
  </div>
  <!-- Languages -->
  <div
    class="my-account-mobile-dialog-content-list"
    *ngFor="let languageNav of languageMobileNavNode"
    [class.no-flags]="!(isLanguageFlagIconEnabled$ | async)"
  >
    <mat-list-item (click)="onClickSubMenu($event, 1)" *ngIf="languageNav.children" disableRipple>
      <mat-icon *ngIf="languageNav.title === 'My Account'" class="material-icons-sharp light">menu</mat-icon>
      <span
        *ngIf="languageNav.title === 'Languages' && activeLanguageCountryIsocode"
        class="flag:{{
          (isCountryFlagInsteadEnabled$ | async) ? (activeCountry$ | async | uppercase) : activeLanguageCountryIsocode
        }} mr-2"
      ></span>
      <span *ngIf="languageNav.title === 'Languages'" class="submenu">{{ activeLanguageName | titlecase }}</span>
      <mat-icon class="material-icons-sharp light ml-auto menu-button" [class.rotated]="showSubSubMenu[1]"
        >expand_more</mat-icon
      >
    </mat-list-item>
    <div
      class="submenu-container"
      [class.expanded]="showSubSubMenu[1]"
      [class.d-none]="!showSubSubMenu[1]"
      *ngIf="languageNav.children && showSubSubMenu[1]"
    >
      <div class="subsubmenu-container d-xl-none" *ngFor="let languageNavChild of languageNav.children">
        <mat-list-item (click)="onClick(languageNavChild.url)" disableRipple *ngIf="languageNavChild.url">
          <span class="submenu">{{ languageNavChild.title | titlecase }}</span>
        </mat-list-item>
        <mat-list-item
          (click)="setShimanoActiveLanguage(languageNavChild.isocode); closeMyAccountMobileDialog()"
          disableRipple
          *ngIf="languageNavChild.isocode"
        >
          <span
            class="flag:{{
              (isCountryFlagInsteadEnabled$ | async)
                ? (activeCountry$ | async | uppercase)
                : languageNavChild.country.isocode
            }} mr-1"
          ></span>
          <span class="subsubmenu" [class.selected]="activeLanguageIsocode === languageNavChild.isocode">{{
            languageNavChild.name | titlecase
          }}</span>
          <mat-icon
            svgIcon="check"
            class="ml-auto md-12 dark"
            *ngIf="activeLanguageIsocode === languageNavChild.isocode"
          ></mat-icon>
        </mat-list-item>
      </div>
    </div>
  </div>
</div>
